/**
 * Registration analytics event names (ACP rebrand v3)
 */
export enum RegistrationEvent {
  CREATE_ACCOUNT_CLICKED = 'CreateAccountClicked',
  EMAIL_OTP_REQUEST_SENT = 'NewAccountEmailOTPRequestSent',
  EMAIL_OTP_SUBMITTED = 'NewAccountEmailOTPSubmitted',
  EMAIL_OTP_VALIDATION_SUCCESS = 'NewAccountEmailOTPValidationSuccess',
  EMAIL_OTP_VALIDATION_FAILED = 'NewAccountEmailOTPValidationFailed',
  PHONE_OTP_REQUEST_SENT = 'NewAccountPhoneOTPRequestSent',
  PHONE_OTP_SUBMITTED = 'NewAccountPhoneOTPSubmitted',
  PHONE_OTP_VALIDATION_SUCCESS = 'NewAccountPhoneOTPValidationSuccess',
  PHONE_OTP_VALIDATION_FAILED = 'NewAccountPhoneOTPValidationFailed',
  PHONE_MFA_CONSENT_OPTED = 'NewAccountPhoneMFAConsentOpted',
  PHONE_MFA_CONSENT_OPTED_OUT = 'NewAccountPhoneMFAConsentOptedOut',
  PHONE_MFA_CONSENT_CONFIRMED = 'NewAccountPhoneMFAConsentConfirmed',
  PHONE_UPDATED = 'NewAccountPhoneUpdated',
  NPS_FEEDBACK_SENT = 'NewAccountNPSFeedbackSent',
  NPS_COMMENT_SKIP = 'NewAccountNPSCommentSkip',
  NPS_FEEDBACK_SKIP = 'NewAccountNPSFeedbackSkip',
  ANDROID_APP_CLICKED = 'NewAccountAndroidAppclicked',
  IOS_APP_CLICKED = 'NewAccountiOSAppclicked',
  CREATE_SUCCESS = 'NewAccountCreateSuccess',
  CREATE_FAILED = 'NewAccountCreateFailed',
  ASSUMPTION_CREATE_SUCCESS = 'AssumptionAccountCreateSuccess',
  ASSUMPTION_CREATE_FAILED = 'AssumptionAccountCreateFailed',
}

export enum RegistrationValuePropEvent {
  REGISTER_CLICK = 'RegisterClicked',
  DOWNLOAD_APP_CLICK = 'DownloadAppClicked',
}

export enum DownloadAppEvent {
  REGISTER_CLICKED = 'RegisterClicked',
  DOWNLOAD_APP_CLICKED = 'DownloadAppClicked',
  WEB_CONTINUE_CLICKED = 'WebContinueClicked',
}

export type RegistrationAnalyticsEvent =
  | RegistrationEvent
  | RegistrationValuePropEvent
  | DownloadAppEvent;

export type TrackRegistrationEventFn = (
  event: RegistrationEvent,
  attributes?: Record<string, unknown>,
) => void;

export type TrackRegistrationValuePropEventFn = (
  event: RegistrationValuePropEvent,
  attributes?: Record<string, unknown>,
) => void;

export type TrackDownloadAppEventFn = (
  event: DownloadAppEvent,
  attributes?: Record<string, unknown>,
) => void;
